import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export const routeConfig = [{
  path: '/',
  redirect: {
    name: 'login'
  }
},
{
  path: '/login',
  name: 'login',
  component: () => import('./views/login.vue')
},
{
  path: '*',
  name: '404',
  component: () => import('@/components/core/core_page/404.vue')
},
{
  path: '/supplier/SupplyRatioQuery',
  name: 'SupplyRatioQuery2',
  component: () => import('@/modules/globalprotal/views/supplier/SupplyRatioQuery')
},
{
  path: '/performance/performanceQueryView',
  name: 'performanceQueryView2',
  component: () => import('@/modules/globalprotal/views/performance/PerformanceQueryView')
},
{
  path: '/performance/performanceQueryDetail',
  name: 'performanceQueryDetail2',
  component: () => import('@/modules/globalprotal/views/performance/PerformanceQueryDetail')
},
{
  path: '/performance/equipmentCapacityMaintenance',
  name: 'equipmentCapacityMaintenance',
  component: () => import('@/modules/globalprotal/views/performance/equipmentCapacityMaintenance')
},
{
  path: '/performance/performanceQueryTrend',
  name: 'PerformanceQueryTrend2',
  component: () => import('@/modules/globalprotal/views/performance/PerformanceQueryTrend')
},
{
  path: '/performance/performanceQueryPoints',
  name: 'PerformanceQueryPoints2',
  component: () => import('@/modules/globalprotal/views/performance/PerformanceQueryPoints')
},
{
  path: '/banner',
  name: 'banner',
  component: () => import('@/modules/index/views/banner')
},
    {
        path: '/suppliesFormOutsideApproval',
        name: 'suppliesFormOutsideApproval',
        component: () => import('@/modules/globalprotal/views/purchaseDistribution/suppliesFormOutsideDetail'),
    },
];
export default new Router({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes: routeConfig,
});
